import { render, staticRenderFns } from "./AddPatientReportModal.vue?vue&type=template&id=e2c62572&"
import script from "./AddPatientReportModal.vue?vue&type=script&lang=js&"
export * from "./AddPatientReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports